import { Component, ErrorInfo, ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center">
          <AlertTriangle className="h-16 w-16 text-primary mb-6" />
          <h1 className="font-display text-3xl font-bold tracking-tight md:text-4xl">
            Something went wrong
          </h1>
          <p className="mt-4 max-w-md text-lg text-muted-foreground">
            We're sorry — an unexpected error occurred. Please try refreshing the page.
          </p>
          <Button
            className="mt-8"
            onClick={() => {
              this.setState({ hasError: false });
              window.location.href = "/";
            }}
          >
            Return to homepage
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}
